import { Theme } from '@mui/material';


const Typography = (theme: Theme) => {
  return {
  };
};

export default Typography;
